export default require("../../node_modules/.pnpm/registry.npmmirror.com+crypto-js@4.1.1/node_modules/crypto-js/index.js");